export default __webpack_public_path__ + "static/media/4516e2ee-f63b-4867-896b-4424cfde36eb 2.b4699a37.JPG";